import TransitApi from './base'
import { createFormData } from '@/helpers/TransitHelper'

export default {
  // Saldo pendiente de facturar, agrupado por cliente.
  async getPending(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/account-statement/pending?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Renglones que entrarían en el estado de cuenta de un cliente.
  async getPendingItems({ clientType, clientId, ...params }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/account-statement/pending/${clientType}/${clientId}?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/account-statement?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getOne({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/account-statement/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async create(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/account-statement', params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async pay({ id, ...params }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/account-statement/${id}/pay`, params)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Elimina un abono mal registrado; el backend recalcula el acumulado y el
  // estado, y devuelve el estado de cuenta ya actualizado.
  async deletePayment({ paymentId }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(
        `/account-statement/payments/${paymentId}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async voidStatement({ id, reason }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/account-statement/${id}/void`, { reason })
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async send({ id }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/account-statement/${id}/send`, {})
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async uploadDocuments({ id, ...params }) {
    try {
      const Api = TransitApi.getSecureInstanceMultipart()
      const data = createFormData(params)
      const result = await Api.post(`/account-statement/${id}/documents`, data)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async deleteDocument({ documentId }) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(
        `/account-statement/documents/${documentId}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },
}
